// socketActions.js
import socketService from '@/services/socketService';
import {
  SOCKET_CONNECT,
  SOCKET_DISCONNECT,
  SOCKET_MESSAGE_RECEIVED,
  SOCKET_NOTIFICATION_RECEIVED,
} from '../ActionType/socketActionType';
import { ApiEndPoint } from '@/services/apiUttiLities';

// connect socket
export const connectSocket = (token) => (dispatch) => {
  // const PORT = process.env.REACT_APP_BACKEND_URL; 
  const PORT = ApiEndPoint; 
  const socket = socketService.connect(PORT, token); // change to your backend URL

  // remove any previously registered handlers to prevent duplicate calls
  socketService.off('message');
  socketService.off('receive_notification');
  socketService.off('receive_incident_sync');

  socketService.on('message', (data) => {
    dispatch({
      type: SOCKET_MESSAGE_RECEIVED,
      payload: data.data,
    });
  });

  socketService.on('receive_notification', (data) => {
    dispatch({
      type: SOCKET_NOTIFICATION_RECEIVED,
      payload: data,
    });
    // ForeSight warnings update live the moment the server raises one.
    if (['EARLY_WARNING', 'EARLY_WARNING_DISPATCH'].includes(data?.type)) {
      window.dispatchEvent(new Event('earlyWarningsChanged'));
    }
  });

  socketService.on('receive_incident_sync', (data) => {
    window.dispatchEvent(new CustomEvent('incidentRealtimeSync', { detail: data }));
  });

  dispatch({ type: SOCKET_CONNECT });
};

// disconnect socket
export const disconnectSocket = () => (dispatch) => {
  socketService.disconnect();
  dispatch({ type: SOCKET_DISCONNECT });
};

// send message
export const sendSocketMessage = (message) => (dispatch) => {
  socketService.emit('send_message', message);
};

export const sendNotificationSocket = (message) => (dispatch) => {
  socketService.emit('send_notification', message);
};

export const readNotificationSocket = (message) => (dispatch) => {
  socketService.emit('read_notification', message);
};